import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

// Pill with a low-opacity color tint sitting behind the children. Used by
// PlanStatusBadge and UrgentBadge to share the same visual idiom.
function TintedPill ({ color, opacity, className, children }) {
  return (
    <div className={clsx('radius-md px-2 relative flex items-center', className)}>
      <div className='absolute radius-md' style={{ inset: 0, opacity, backgroundColor: color }} />
      <div className='relative flex items-center' style={{ gap: '4px' }}>{children}</div>
    </div>
  )
}

TintedPill.propTypes = {
  color: PropTypes.string.isRequired,
  opacity: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node
}

TintedPill.defaultProps = {
  opacity: 0.35
}

export default TintedPill
